import { FC } from 'react';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import { State } from 'redux/initialState';
import { useSelector } from 'react-redux';
import { useTranslate } from 'hooks/useTranslate';

import { useGetOperationTypeOptions } from './hooks/useGetOperationTypeOptions';

type OperationTypesSelectorProps = {
  onChangeTypes?: (types: string[]) => void; // eslint-disable-line
};

const OperationTypesSelector: FC<OperationTypesSelectorProps> = ({
  onChangeTypes,
}) => {
  const { t } = useTranslate();
  const animatedComponents = makeAnimated();

  const actualSociety = useSelector(
    (state: State) => state.society.actualSociety
  );

  const { data, actions } = useGetOperationTypeOptions({
    society: actualSociety,
    onChangeTypes,
  });

  return (
    <Select
      className="react-select w-250px"
      value={data.selectedOperationTypeOptions}
      options={data.operationTypeOptions}
      components={animatedComponents}
      onChange={actions.handleChangeOperationTypeOptions}
      placeholder={t('FilterByOperation')}
      isClearable
      styles={{
        menuPortal: (base) => ({
          ...base,
          zIndex: 9999,
        }),
      }}
    />
  );
};

export default OperationTypesSelector;
